var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGiftIcons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "#494dcb",
    strokeWidth: 1.25
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.529,
    y: 7.116,
    width: 28.943,
    height: 6.834,
    rx: 1.333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.976 13.95h26.048v13.7c0 .736-.597 1.333-1.333 1.333H4.309a1.333 1.333 0 01-1.333-1.333v-13.7zM16 6.433v22.551M15.277 7.117c2.894-1.367 5.949-4.784 9.567-4.784a3.45 3.45 0 013.457 4.784"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.724 7.117C13.83 5.75 11.207 2.333 7.157 2.333A3.45 3.45 0 003.7 7.117"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIiBzdHJva2U9IiM0OTRkY2IiIHN0cm9rZS13aWR0aD0iMS4yNSIgeG1sbnM6dj0iaHR0cHM6Ly92ZWN0YS5pby9uYW5vIj48cmVjdCB4PSIxLjUyOSIgeT0iNy4xMTYiIHdpZHRoPSIyOC45NDMiIGhlaWdodD0iNi44MzQiIHJ4PSIxLjMzMyIvPjxwYXRoIGQ9Ik0yLjk3NiAxMy45NWgyNi4wNDhWMjcuNjVjMCAuNzM2LS41OTcgMS4zMzMtMS4zMzMgMS4zMzNINC4zMDljLS43MzYgMC0xLjMzMy0uNTk3LTEuMzMzLTEuMzMzVjEzLjk1eiIvPjxwYXRoIGQ9Ik0xNiA2LjQzM3YyMi41NTEiLz48cGF0aCBkPSJNMTUuMjc3IDcuMTE3YzIuODk0LTEuMzY3IDUuOTQ5LTQuNzg0IDkuNTY3LTQuNzg0YTMuNDUgMy40NSAwIDAgMSAzLjQ1NyA0Ljc4NCIvPjxwYXRoIGQ9Ik0xNi43MjQgNy4xMTdDMTMuODMgNS43NSAxMS4yMDcgMi4zMzMgNy4xNTcgMi4zMzNBMy40NSAzLjQ1IDAgMCAwIDMuNyA3LjExNyIvPjwvc3ZnPg==";
export { SvgGiftIcons as ReactComponent };